import { useLocation } from 'react-router';
import { useState, useEffect } from 'react';

function useIsNavigating() {
  const location = useLocation();
  const [isNavigating, setIsNavigating] = useState(false);

  // The flag exists precisely to mark the render right after a route change
  // (consumers use it to skip redirect-on-mount logic during in-session
  // navigation), so the synchronous setState is the behaviour, not a mistake.
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsNavigating(true);

    const timeout = setTimeout(() => setIsNavigating(false), 0);
    return () => clearTimeout(timeout);
  }, [location]);

  return isNavigating;
}

export default useIsNavigating;